module.exports = __webpack_public_path__ + "img/Fares-Collections.4fd28f45.png";